import request from '@/utils/request'
export default {
  getTransferList(params) {
    return request.get('/orders/wait-make-transfer/list', {
      params
    })
  }
}
